var _polygon, _polygon2, _polygon3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgMyAssetTripleIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  focusable: "false",
  viewBox: "1 1 27 27"
}, props), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
  points: "5.94 28.28 5.01 24.5 1.23 23.57 5.01 22.64 5.94 18.85 6.87 22.64 10.66 23.57 6.87 24.5 5.94 28.28"
})), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
  points: "23.48 10.57 22.55 6.79 18.77 5.86 22.55 4.93 23.48 1.14 24.41 4.93 28.19 5.86 24.41 6.79 23.48 10.57"
})), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
  points: "12.22 21.94 10.36 14.34 2.76 12.48 10.36 10.61 12.22 3.02 14.09 10.61 21.68 12.48 14.09 14.34 12.22 21.94"
})));
export default SvgMyAssetTripleIcon;